import React from 'react';
import { motion } from 'framer-motion';
import { useAnimateXPBar } from '../../../hooks/useAnimateXPBar';

const XPBar = ({ current_level, previous_level, delta_level }) => {
  const {
    bar_controls,
    xp_gained_controls,
    bar_scale_controls,
    bar_width_percent,
    current_display_xp_value,
    current_bar_color_value,
  } = useAnimateXPBar({
    current_level_prop: current_level,
    previous_level_prop: previous_level,
    delta_level_prop: delta_level,
  });

  const positions = ['20%', '40%', '60%', '80%'];

  return (
    <div className="flex flex-col gap-2 w-full">
      <div className="relative h-6 text-center">
        <motion.span
          className="absolute inset-x-0 text-lg font-semibold text-[#1d4746] dark:text-slate-200"
          initial={{ opacity: 0, y: 10 }}
          animate={xp_gained_controls}
        >
          {delta_level >= 0 ? '+' : ''}
          {(delta_level * 100).toFixed(0)} XP
        </motion.span>
      </div>

      <div className="flex items-center gap-3">
        <span className="text-sm font-bold w-fit shrink-0 text-left -skew-x-[10deg] text-[#1d4746] dark:text-slate-200">
          Progress Level:
        </span>

        <div className="grow relative -skew-x-[10deg]">
          <div className="absolute -top-5 right-2 text-xs font-medium z-20 skew-x-[10deg] text-[#1d4746] dark:text-slate-200">
            {`${current_display_xp_value} / 100`}
          </div>

          <div className="w-full h-5 rounded-md overflow-hidden relative bg-slate-700 border border-[hsl(var(--primary-foreground))] dark:bg-slate-400/15 dark:border-slate-400/20">
            {positions.map((pos, index) => (
              <div
                key={index + 1}
                className="absolute top-0 bottom-0 w-0.5 bg-slate-500/50"
                style={{ left: pos }}
              />
            ))}
            <motion.div
              className="h-full rounded-md relative z-10 origin-center"
              animate={bar_scale_controls}
            >
              <motion.div
                className="h-full rounded-md relative z-10"
                style={{
                  backgroundColor: current_bar_color_value,
                  width: bar_width_percent,
                }}
                initial={{ width: `${(previous_level % 1) * 100}%` }}
                animate={bar_controls}
              />
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default XPBar;
